import { ComponentElem } from "@components/interfaces";
import PopupBase from "./PopupBase";
import FormTools from "@root/ts/FormTools";
import Tools from "@root/ts/Tools";
import Popups from "./Popups";

export default class LoginBindLine extends PopupBase
{
  static instance: LoginBindLine;

  autoClose_cover: boolean = false;

  _nextUrl: string;

  constructor(elem: ComponentElem)
  {
    super(elem);

    LoginBindLine.instance = this;

    this.$root.find(".close").on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      // FormTools.handleNextUrl({next_url: this._nextUrl});
      Popups.close();
    });
  }

  setNextUrl(url: string)
  {
    this._nextUrl = url;
  }
}